<div id="saleTransactions-wrapper">
  <div class="sales-line-header" [ngClass]="{ 'has-scrollbars': hasScrollbars }">
    <div class="sku">Product</div>
    <div class="qty">Qty</div>
    <div class="line-discount">{{ _isMobile ? "Unit Disc." : "Unit Discount" }}</div>
    <div class="sale-price-col">Unit Cost</div>
    <div class="total-price">Total</div>
  </div>
  <div class="sale-lines" #saleLines>
    <div *ngFor="let purchaseDocLine of purchaseDoc.purchaseDocLines" class="sale-line">
      <div class="line-desc">
        {{ purchaseDocLine.docLine?.inventory?.description1 }}
      </div>
      <div class="line-body">
        <div class="sku">
          SKU:
          <a
            (click)="
              skuStockPanel.toggle($event); populateStockAvailabilityDialog(purchaseDocLine.docLine?.inventory?.id)
            "
          >
            {{ purchaseDocLine.docLine?.inventory?.sku }}
          </a>
        </div>

        <p-overlayPanel #skuStockPanel [showCloseIcon]="true" appendTo="body" styleClass="formlist-panelOverlay">
          <h3>Stock Levels</h3>
          <p-table
            id="main-table"
            [scrollable]="true"
            [scrollHeight]="tableScrollHeight"
            tableStyle="table-layout:fixed"
            responsiveLayout="stack"
            breakpoint="640px"
            [value]="_inventoryStockFormArray['controls']"
            styleClass="p-datatable-striped"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="stockName-col">Stock</th>
                <th class="onHand-col">OH Qty</th>
                <th class="committedQty-col">Commited Qty</th>
                <th class="onOrder-col">On Order Qty</th>
                <th class="minStock-col">Min Stock Qty</th>
                <th class="maxStock-col">Max Stock Qty</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-formGroup>
              <tr>
                <taku-inventory-stock [formGroup]="formGroup" [displayMode]="_displayMode"></taku-inventory-stock>
              </tr>
            </ng-template>
          </p-table>
        </p-overlayPanel>
        <div class="qty">{{ purchaseDocLine.qty | formatNegativeNumber }}</div>
        <div class="line-discount">
          <ng-template [ngIf]="purchaseDocLine.allocatedDiscountAmount > 0">
            {{
              convertedUnitDiscount(purchaseDocLine)
                | currency : purchaseDoc.doc.currencyIsoCode : "symbol-narrow" : "1.2"
            }}
            <span *ngIf="purchaseDocLine.discountType === DiscountType.Percentage"
              ><br />({{ purchaseDocLine.discountAmount | number : "1.2" }}%)</span
            >
          </ng-template>
        </div>
        <div class="sale-price-col">
          <div class="sale-price">
            {{
              convertedUnitCost(purchaseDocLine) | currency : purchaseDoc.doc.currencyIsoCode : "symbol-narrow" : "1.2"
            }}
          </div>
          <div *ngIf="purchaseDocLine.allocatedDiscountAmount != 0" class="original-price">
            {{ purchaseDocLine.unitPrice | currency : purchaseDoc.doc.currencyIsoCode : "symbol-narrow" : "1.2" }}
          </div>
        </div>
        <div class="total-price">
          <span class="total-amount">{{
            purchaseDocLine.qty * purchaseDocLine.unitPrice - convertedTotalDiscountAmount(purchaseDocLine)
              | currency : purchaseDoc.doc.currencyIsoCode : "symbol-narrow" : "1.2"
              | formatNegativeNumber
          }}</span>
          <span class="tax-acronyms">{{ InvoiceHelpers.GetCombinedTaxAcronyms(purchaseDocLine) }}</span>
        </div>
      </div>
      <div class="saleTransactions-purchaseDocLine-details">
        <span
          ><i class="material-icons">bookmark_border</i>
          {{ inventoryVariantsStr(purchaseDocLine.docLine?.inventory) }}</span
        >
      </div>
      <div *ngIf="purchaseDocLine.docLine?.note" class="line-notes">Note: {{ purchaseDocLine.docLine?.note }}</div>
    </div>
  </div>

  <div class="summary-wrapper">
    <div *ngIf="purchaseDoc.doc.comment" class="invoice-notes">
      <h3>Invoice Notes</h3>
      <p>
        {{ purchaseDoc.doc.comment }}
      </p>
    </div>
    <div class="summary">
      <table cellspacing="0">
        <tr>
          <td class="label-col">Sub-total:</td>
          <td class="amount-col">
            {{
              purchaseDoc.subTotal - purchaseDocGeneralDiscount
                | currency : purchaseDoc.doc.currencyIsoCode : "symbol-narrow" : "1.2"
                | formatNegativeNumber
            }}
          </td>
        </tr>

        <tr>
          <td class="label-col">- Discount:</td>
          <td class="amount-col">
            {{ 0 | currency : purchaseDoc.doc.currencyIsoCode : "symbol-narrow" : "1.2" | formatNegativeNumber }}
          </td>
        </tr>

        <tr>
          <td class="label-col">
            <a
              *ngIf="isTaxConflict()"
              href="javascript://"
              (click)="taxesPanel.toggle($event)"
              [style.color]="getTaxFontColor()"
              class="pi pi-info-circle"
            >
            </a>
            <a href="javascript://" (click)="taxesPanel.toggle($event)" style="float: right">
              <ins [style.color]="getTaxFontColor()">+ Taxes:</ins>
            </a>
            <p-overlayPanel #taxesPanel [showCloseIcon]="false" appendTo="body">
              <div class="col-12">
                <table *ngIf="purchaseDoc.groupedTaxLines?.length">
                  <ng-template ngFor [ngForOf]="purchaseDoc.groupedTaxLines" let-tax>
                    <tr class="tax-info">
                      <td class="tax-desc">
                        <span>{{ tax?.saleTaxRule?.tax?.shortDesc }}</span>
                      </td>
                      <td class="tax-amount">
                        <span>{{
                          tax?.total
                            | currency : purchaseDoc.doc.currencyIsoCode : "symbol-narrow" : "1.2"
                            | formatNegativeNumber
                        }}</span>
                      </td>
                    </tr>
                    <tr class="separator">
                      <td colspan="3">
                        <hr />
                      </td>
                    </tr>
                  </ng-template>
                </table>
                <div *ngIf="!purchaseDoc?.groupedTaxLines?.length" class="no-taxes"
                  >There are no taxes for this sale yet.
                </div>
              </div>
            </p-overlayPanel>
          </td>
          <td class="amount-col">
            {{
              purchaseDoc.totalLineTax
                | currency : purchaseDoc.doc.currencyIsoCode : "symbol-narrow" : "1.2"
                | formatNegativeNumber
            }}
          </td>
        </tr>

        <tr>
          <td class="label-col">+ Shipping:</td>
          <td class="amount-col">
            {{
              purchaseDoc.shipperChargeAmount
                | currency : purchaseDoc.doc.currencyIsoCode : "symbol-narrow" : "1.2"
                | formatNegativeNumber
            }}
          </td>
        </tr>

        <tr class="total-line">
          <td class="label-col">TOTAL:</td>
          <td class="amount-col">
            {{
              purchaseDoc.grandTotal
                | currency : purchaseDoc.doc.currencyIsoCode : "symbol-narrow" : "1.2"
                | formatNegativeNumber
            }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="_activeDialog"
  [contentStyle]="{ maxHeight: '100%' }"
  header="Confirmation"
  styleClass="fixedsize-modal"
  [blockScroll]="true"
  [modal]="true"
>
  <p>
    {{ _dialogContent }}
  </p>
  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-check"
      (click)="_activeDialog = false"
      label="Ok"
      styleClass="p-button-text"
    ></p-button> </ng-template
></p-dialog>
